import React, { useState, useEffect, useLayoutEffect } from "react";
import Picker from "react-simple-picker";

const WeightChange = ({ label, onSizeChange, kgFromParent, grFromParent }) => {
  const [selectedKilogram, setSelectedKilogram] = useState(0);
  const [selectedGram, setSelectedGram] = useState(0);
  const [pickerHeight, setPickerHeight] = useState(
    window.innerWidth > 768 ? 250 : 120
  );

  useEffect(() => {
    if (kgFromParent !== undefined || grFromParent !== undefined) {
      setSelectedKilogram(parseInt(kgFromParent, 10));
      setSelectedGram(parseInt(grFromParent, 10));
    }
  }, [kgFromParent, grFromParent]);

  useLayoutEffect(() => {
    setPickerHeight(window.innerWidth > 768 ? 250 : 120);
  }, []);

  const kilograms = Array.from({ length: 100 }, (_, index) => index);
  const grams = Array.from({ length: 1000 }, (_, index) => index);

  const handleGrams = (index) => {
    setSelectedGram(index);
  };

  const handleKilograms = (index) => {
    setSelectedKilogram(index);
  };

  useEffect(() => {
    onSizeChange(label, selectedKilogram, selectedGram);
  }, [selectedKilogram, selectedGram]);

  const customStyle = {
    background: "transparent",
    fontSize: "20px",
    color: "#fff",
  };

  return (
    <div className="sizeSelectorWrapper centeredFlex">
      <div className="sizeSelectorField">
        <Picker
          height={pickerHeight}
          initCount={selectedGram}
          preloadCount={50}
          iconAdd={null}
          iconMinus={null}
          optionGroups={{ gr: grams }}
          valueGroups={{ gr: selectedGram }}
          maxCount={999}
          minCount={-999}
          onChange={(valueIndex) => handleGrams(valueIndex)}
          renderMask={(Mask) => (
            <Mask
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "0 1rem 1rem 0",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderLeft: "none",
                paddingRight: "15px",
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                gap: "0.25rem",
                alignItems: "center",
              }}
            >
              <span>gr</span>
            </Mask>
          )}
          style={customStyle}
        />
      </div>
      <div className="sizeSelectorField">
        <Picker
          height={pickerHeight}
          initCount={selectedKilogram}
          preloadCount={50}
          iconAdd={null}
          iconMinus={null}
          optionGroups={{ k: kilograms }}
          valueGroups={{ k: selectedKilogram }}
          maxCount={99}
          minCount={-99}
          onChange={(valueIndex) => handleKilograms(valueIndex)}
          renderMask={(Mask) => (
            <Mask
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "1rem 0 0 1rem",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRight: "none",
                paddingRight: "15px",
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                gap: "0.25rem",
                alignItems: "center",
              }}
            >
              <span>k</span>
            </Mask>
          )}
          style={customStyle}
        />
      </div>
    </div>
  );
};

export default WeightChange;
